import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ess-column-left',
  templateUrl: './column-left.component.html',
  styleUrls: ['./column-left.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ColumnLeftComponent {}
